module.exports = __webpack_public_path__ + "img/2_windAndRain_fhm.16bec91b.png";